export const environment = {
  production: true,
  googleAnalyticsId: 'G-68PTF7M4QG',
  services: {
    identity: 'https://api.ticket-bangla.com',
    events: 'https://api.ticket-bangla.com',
    admin: 'https://api.ticket-bangla.com',
    bookings: 'https://api.ticket-bangla.com',
    booking: 'https://api.ticket-bangla.com',
    tickets: 'https://api.ticket-bangla.com',
    ticketing: 'https://api.ticket-bangla.com',
    userissue: 'https://api.ticket-bangla.com',
    userissuehub: 'wss://chat.ticket-bangla.com'
  },
  baseUrl: 'https://admin.ticket-bangla.com',
  headerkey: '9KfR2aTqY8H6ZP0xWgU7mJvL4nQbD1SIEA',
  aws: {
    region: 'ap-southeast-1',
    userPoolId: 'ap-southeast-1_KqmyB54Cp',
    userPoolWebClientId: '6ifefngiunmg4re200r0v0qq2h',
  },
  homePageSettings: {
    homeTotalEvents: 8,
    fourImage: 4,
    eventContentImage: 'assets/icons/homepage/event-content-image.png',
  },
  serverless: {
    baseUrl: 'https://auth.ticket-bangla.com',
    authorization: '9KfR2aTqY8H6ZP0xWgU7mJvL4nQbD1SIEA'
  },
  cloudFront: {
    cloudFrontUrl: 'https://d1tnbfpge2u80k.cloudfront.net',
    mainDomain: 'ticket-bangla.com'
  }
};
